import { pagination } from '../../data/labels';
import styles from './Pagination.module.scss';

interface PaginationProps {
  pageCount: number;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const Pagination = ({ pageCount, currentPage, setCurrentPage }: PaginationProps) => {

  const MAX_VISIBLE_PAGES = 15;

  const getPaginationRange = (currentPage: number, pageCount: number) => {
    if (pageCount <= MAX_VISIBLE_PAGES) {
      return [0, pageCount];
    }

    const half = Math.floor(MAX_VISIBLE_PAGES / 2);
    let start = currentPage - half;
    let end = currentPage + half + 1;

    if (start < 0) {
      start = 0;
      end = MAX_VISIBLE_PAGES;
    } else if (end > pageCount) {
      end = pageCount;
      start = pageCount - MAX_VISIBLE_PAGES;
    }

    return [start, end];
  };

  const [start, end] = getPaginationRange(currentPage, pageCount);

  return (
    <div className={styles.pagination}>
      <div onClick={() => setCurrentPage(0)}>{pagination.start}</div>
      <div onClick={() => setCurrentPage(currentPage === 0 ? 0 : currentPage - 1)}>
        {pagination.previous}
      </div>
      <div className={styles.pageNumbers}>
        {0 < start ? '...' : ''}
        {Array(end - start)
          .fill(undefined)
          .map((_, i) => {
            const pageIndex = start + i;
            return (
              <div
                key={pageIndex}
                className={pageIndex === currentPage ? styles.active : ''}
                onClick={() => setCurrentPage(pageIndex)}
              >
                {pageIndex + 1}
              </div>
            );
          })}
          {pageCount > end ? '...' : ''}
      </div>
      <div
        onClick={() =>
          setCurrentPage(currentPage === pageCount - 1 ? currentPage : currentPage + 1)
        }
      >
        {pagination.next}
      </div>
      <div onClick={() => setCurrentPage(pageCount - 1)}>{pagination.end}</div>
    </div>
  );
};

export default Pagination;
